module.exports = __webpack_public_path__ + "img/generalmobile-gm5-plus.a19631bb.jpg";